(function(){
  var overlay;

  PegasusTemplate.Command = Em.Object.extend({
    execute: function(){
      var manager = PegasusTemplate.get('CommandManager.instance');
      manager.incrementProperty( 'version' );

      // we want the overlay for the standard duration
      // of a history operation

      manager.didExecute(this);

      if ( !this.get('timestamp') ){
        this.set('timestamp', PegasusTemplate.Helpers.strftime( new Date(), '%l:%M%P %Z') );
      }

      $(window).trigger('considerHidden');

      var evt = document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    },
    unexecute: function(){
      var manager = PegasusTemplate.get('CommandManager.instance');
      manager.incrementProperty( 'version' );
      manager.set('isRolling', true);
      manager.set('isRolling', false);
      manager.didUnexecute(this);

      $(window).trigger('considerHidden');
    },
    init: function(){
      var manager = PegasusTemplate.get('CommandManager.instance');
      // it is assumed that an execute will happen shortly
      // after initialization of a command
      manager.blockInteraction();

      this._super();
      manager.addObject( this );
    }
  });
})();
